import React from 'react';
import { Field, useField } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import CommonTextarea from '../../../../../../components/common-textarea/CommonTextarea';
import WithError from '../../../../../../components/with-error/WithError';
import WithLabel, { LABEL_STYLES } from '../../../../../../components/with-label/WithLabel';
import TooltipButton from '../../../../../../components/tooltip-button/TooltipButton';
import { BUTTON_STYLES } from '../../../../../../components/common-button/CommonButton';
import Icon from '../../../../../../icons/Icon';
import { ICONS } from '../../../../../../icons';
import { ACTIV8_MESSAGE_GENERATE_TABS } from '../../../../../../constants';

import scss from './RepliesForm.module.scss';

function RepliesFormInner({ onSubmit }) {
  const { t } = useTranslation('scout');

  const { input: hintInput } = useField('hint');

  const isFormLoading = useSelector((state) => state.activ8Messages.isFormLoading);
  const isResetting = useSelector((state) => state.activ8Messages.isResetting);
  const isGenerating = useSelector((state) => state.activ8Messages.isGenerating);
  const generateTab = useSelector((state) => state.activ8Messages.generateTab);

  const isDisabled =
    !hintInput.value ||
    isFormLoading ||
    isResetting ||
    generateTab !== ACTIV8_MESSAGE_GENERATE_TABS.GENERATED ||
    isGenerating;

  return (
    <div className={scss.repliesForm}>
      <Field name='hint'>
        {({ input, meta }) => (
          <WithLabel variant={LABEL_STYLES.ROW} label={t('hints')} isBold extraClassName={scss.hintsField} isTwoDots>
            <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
              <CommonTextarea
                name={input.name}
                value={input.value}
                isReadOnly
                rows='2'
                resize='none'
                isError={meta.touched && meta.error}
                disabled={isDisabled}
              />
            </WithError>
          </WithLabel>
        )}
      </Field>

      <Field name='reply'>
        {({ meta, input }) => (
          <WithLabel variant={LABEL_STYLES.ROW} label={t('replies')} isBold extraClassName={scss.hintsField} isTwoDots>
            <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
              <CommonTextarea
                name={input.name}
                value={input.value}
                onChange={input.onChange}
                rows='2'
                resize='none'
                isReadOnly={isFormLoading}
                isError={meta.touched && meta.error}
                disabled={isDisabled}
                onEnter={onSubmit}
                enableVoiceInput
              />
            </WithError>
          </WithLabel>
        )}
      </Field>

      <TooltipButton
        type='submit'
        styleColor={BUTTON_STYLES.SECONDARY}
        onClick={onSubmit}
        maxWidth={140}
        disabled={isDisabled}
        tooltip={isGenerating && t('messagesGenerating')}>
        <Icon icon={ICONS.ArrowUp} />
      </TooltipButton>
    </div>
  );
}

export default RepliesFormInner;
